import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { GeolocationDataBuilder } from './geolocation-data.builder';
import { GeolocationDataResolve } from './geolocation-data.resolve';
import { GeolocationDataService } from './geolocation-data.service';

@NgModule({
  imports: [CommonModule],
  declarations: [],
})
export class GeolocationDataModule {
  static forRoot(): ModuleWithProviders<GeolocationDataModule> {
    return {
      ngModule: GeolocationDataModule,
      providers: [
        GeolocationDataService,
        GeolocationDataResolve,
        GeolocationDataBuilder,
      ],
    };
  }
}
